import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { sv } from 'date-fns/locale';
import React from 'react';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { createRoot } from 'react-dom/client';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import App from './App';
import Providers from './Providers';
import './assets/fonts/fonts.css';
import './i18n';
import GlobalStyle from './layout/global-style';
import theme from './layout/theme';

registerLocale('sv', sv);
setDefaultLocale('sv');

// Router 7: data-router, eftersom useBlocker (navigeringsvakten i
// beställningsflödet) bara fungerar i en sådan. Hela appen ligger som ett
// splat-element; sidorna matchas av <Routes> i routes/index.tsx.
const router = createHashRouter([
  {
    path: '*',
    element: (
      <Providers>
        <ThemeProvider theme={theme}>
          <GlobalStyle theme={theme} />
          <App />
        </ThemeProvider>
      </Providers>
    ),
  },
]);

createRoot(document.querySelector('#root') as HTMLElement).render(
  <RouterProvider router={router} />
);
